<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="flex-row space-between">
        <div>
          <h3>{{ reservationTitle }}</h3>
          <span class="subtitle hidden-sm hidden-xs">{{ dateRange }}</span>
        </div>
        <div class="well well-sm pull-right" v-if="isPaymentPlanOrder">
          <h3><i class="fa fa-fw fa-1x fa-lock"></i> {{_('Order') }}: {{ orderId }}</h3>
          <h3><i class="fa fa-fw fa-1x fa-calendar"></i> {{_('Reservation') }}: {{ reservationId }}</h3>
        </div>
        <div class="well well-sm pull-right" v-else-if="isInvoicedOrder">
          <h3><i class="fa fa-fw fa-1x fa-lock"></i> {{_('Order') }}: {{ orderId }}</h3>
          <h3><i class="fa fa-fw fa-1x fa-calendar"></i> {{_('Reservation') }}: {{ reservationId }}</h3>
        </div>
        <div class="well well-sm well-warning" v-else-if="isConfirmedOrder">
          <h3><i class="fa fa-fw fa-1x fa-unlock"></i> {{_('Confirmed order') }}: {{ orderId }}</h3>
          <h3><i class="fa fa-fw fa-1x fa-calendar"></i> {{_('Reservation') }}: {{ reservationId }}</h3>
        </div>
        <div class="well well-sm well-info" v-else-if="isOpenOrder">
          <h3><i class="fa fa-fw fa-1x fa-unlock"></i> {{_('Open order') }}: {{ orderId }}</h3>
          <h3><i class="fa fa-fw fa-1x fa-calendar"></i> {{_('Reservation') }}: {{ reservationId }}</h3>
        </div>
        <div class="well well-sm" v-else-if="isReservation">
          <h3><i class="fa fa-fw fa-1x fa-unlock"></i> {{_('Reservation') }}: {{ reservationId }}</h3>
        </div>
      </div>
      <lock-info v-if="isAnonymizedRecord" :locked="true" :lockStatus="anonymizedLockStatus" :readOnly="true" />
      <lock-info v-else-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <div class="flex-row form-group" v-if="reservation">
        <button v-if="!reservation.checkin_ts" type="button" class="btn btn-success" v-on:click="checkIn"><i class="fa fa-fw fa-sign-in"></i> {{ _('Check in') }}</button>
        <button v-else type="button" class="btn btn-default" v-on:click="cancelCheckIn"><i class="fa fa-fw fa-check"></i> {{ _('Checked in') }} {{ $filters.timestampToDate(reservation.checkin_ts) }} {{ _('at') }} {{ $filters.timestampToTime(reservation.checkin_ts) }}</button>
        <button v-if="!reservation.checkout_ts" type="button" class="btn btn-info" v-on:click="checkOut" :disabled="reservation.checkin_ts ? false : 'disabled'"><i class="fa fa-fw fa-sign-out"></i> {{ _('Check out') }}</button>
        <button v-else type="button" class="btn btn-default" v-on:click="cancelCheckOut"><i class="fa fa-fw fa-check"></i> {{ _('Checked out') }} {{ $filters.timestampToDate(reservation.checkout_ts) }} {{ _('at') }} {{ $filters.timestampToTime(reservation.checkout_ts) }}</button>
      </div>
      <div class="row" v-if="reservation">
        <div class="col-md-12">
          <p class="text-danger" v-if="true || isLocked"><i>{{ _('Please note that any changes you make to the reservation contact information will not be propagated to the associated order or the customer database.') }}</i></p>
          <p class="text-success" v-else-if="false && isOrder"><i>{{ _('Please note that any changes to the reservation details will be applied to both the reservation and its associated order.') }} {{ _('This is possible because the order has not been converted to an invoice yet.') }}</i></p>
          <h3>{{ _('Reserved by') }}</h3>
          <div class="form-group">
            <label for="client_name">{{ _('Customer') }}</label>
            <input id="clientTitle" class="form-control" name="client_name" type="text" v-model="reservation.client_name" />
          </div>
          <div class="form-group">
            <label for="client_company">{{ _('Company') }}</label>
            <input id="clientCompany" class="form-control" name="client_company" type="text" v-model="reservation.client_company" />
          </div>
          <div class="form-group">
            <label for="client_email">{{ _('Email') }}</label>
            <input id="clientEmail" class="form-control" name="client_email" type="email" v-model="reservation.client_email" />
          </div>
          <div class="form-group">
            <label for="client_phone">{{ _('Telephone') }}</label>
            <input id="clientPhone" class="form-control" name="client_phone" type="text" v-model="reservation.client_phone" />
          </div>
          <div class="form-group">
            <label for="client_more">{{ _('More details') }}</label>
            <textarea id="moreDetails" class="form-control" name="client_more" rows="5" cols="40" wrap="virtual" :placeholder="_('Optional extra information related to the reservation.')" v-model="reservation.client_more"></textarea>
          </div>
          <div class="form-group" v-if="showOrderFields">
            <label for="notes">{{ _('Notes') }}</label>
            <textarea id="notes" class="form-control" name="more" rows="5" cols="40" wrap="virtual" :placeholder="_('Notes')" v-model="order.notes"></textarea>
          </div>
          <div class="form-group" v-if="reservation.igloohome_pin">
            <label for="igloohome_pin">{{ _('Igloohome PIN') }}</label>
            <input id="igloohome_pin" class="form-control" disabled="disabled" v-model="reservation.igloohome_pin" />
          </div>
          <div class="form-group" v-if="reservation.ratna_pin">
            <label for="ratna_pin">{{ _('Ratna PIN') }}</label>
            <input id="ratna_pin" class="form-control" disabled="disabled" v-model="reservation.ratna_pin" />
          </div>
          <div class="form-group" v-for="pin in reservation.ownPin">
            <template v-if="pin.provider === 'igloohome'">
              <label for="igloohome_pin">{{ _('Igloohome PIN') }}</label>
              <input id="igloohome_pin" class="form-control" disabled="disabled" v-model="pin.code" />
            </template>
            <template v-else-if="pin.provider === 'ratna'">
              <label for="ratna_pin">{{ _('Ratna PIN') }}</label>
              <input id="ratna_pin" class="form-control" disabled="disabled" v-model="pin.code" />
            </template>
            <template v-else>
              <label for="generic_pin">{{ _('PIN code') }} <template v-if="pin.smartdevice"> ({{ pin.smartdevice.name }})</template></label>
              <input id="generic_pin" class="form-control" disabled="disabled" v-model="pin.code" />
            </template>
          </div>
          <div class="form-group" v-if="showPricetierSelectors">
            <h3>{{ _('Participants') }}</h3>
            <pricetier-selector v-for="pricetier in product.sharedPricetier" :pricetier="pricetier" :key="pricetier.id" v-model="pricetiers[pricetier.id]">
            </pricetier-selector>
          </div>
          <div class="form-group" v-if="showParticipantSelector">
            <h3>{{ _('Participants') }}</h3>
            <select class="form-control" name="count" v-model="reservation.count">
              <option v-for="loop in 1000" :value="loop">{{ loop }}</option>
            </select>
          </div>
          <div class="form-group" v-if="reservation.item && reservation.item.rateplan_name">
            <label for="rateplan_name">{{ _('Rate plan') }}</label>
            <input id="rateplanName" class="form-control" name="rateplan_name" type="text" disabled="disabled" :value="reservation.item.rateplan_name" />
          </div>
          <div class="alert alert-warning" v-if="itemWarnings.length">
            <div v-for="warning in itemWarnings"><i class="fa fa-fw fa-warning"></i> {{ warning }}</div>
          </div>
          <div v-if="reservation.externalid">
            <hr />
            <div class="form-group">
              <h3>{{ _('Backend') }}</h3>
            </div>
            <div class="form-group">
              <label for="externalid">{{ _('Reservation ID in the backend system') }}</label>
              <input id="externalId" class="form-control" name="externalid" type="text" v-model="reservation.externalid" disabled="disabled" />
            </div>
          </div>
          <hr/>
          <div class="form-group">
            <h3>{{ _('Resources') }}</h3>
          </div>
          <div class="reservationdetails-resources resources list-group" id="resourcesList">
            <span v-for="resource in reservation.sharedResource" class="reservationdetails-resource-wrap list-group-item">
              <h4 class="list-group-item-heading reservationdetails-resource" style="margin-top: 8px">
                <span class="reservationdetails-resource-name">{{ resource.name }}</span>
                <select class="reservationdetails-resource-count resourcecount form-control" v-model="resourceSeats[resource.id]" v-if="resource.displayedtype !== 'openinghours'">
                  <option v-for="loop in getResourceCount(resource)" :value="loop">{{ loop }}</option>
                </select>
                <span class="reservationdetails-resource-remove removeitem fa fa-fw fa-close" v-on:click="removeResource(resource)"></span>
              </h4>
            </span>
          </div>
          <div class="form-group">
            <div class="input-group">
              <client-only>
                <v-select v-model="selectedResource" label="name" :filterable="false" :options="resources" v-on:search="onResourceSearch" class="resourceSelector">
                  <template v-slot:no-options="{ searching }">
                    <template v-if="searching">
                      {{ _('No results found.') }}
                    </template>
                    <template v-else>{{ _('Type to search resources') }}</template>
                  </template>
                  <template v-slot:option="option">
                    <div class="d-center">
                      {{ option.id }}: {{ option.name }}
                    </div>
                  </template>
                  <template v-slot:selected-option="option">
                    <div class="selected d-center">
                      {{ option.id }}: {{ option.name }}
                    </div>
                  </template>
                </v-select>
              </client-only>
              <span class="input-group-btn">
                <button class="btn btn-success" type="button" aria-disabled="false" v-on:click="addResource"><i class="fa fa-fw fa-plus"></i> {{ _('Add') }}</button>
              </span>
            </div>
          </div>
          <hr/>
          <div class="form-group">
            <h3>{{ _('Times') }}</h3>
          </div>
          <div class="form-group">
            <label for="creation_ts">{{ _('Creation time') }}</label>
            <div class="flex-row">
              <input id="reservationCreatedDate" class="form-control" name="creation_date" type="text" disabled v-model="creationDate" />
              <input id="reservationCreatedTime" class="form-control" name="creation_time" type="text" disabled v-model="creationTime" />
            </div>
          </div>
          <div class="form-group">
            <label for="update_ts">{{ _('Latest change') }}</label>
            <div class="flex-row">
              <input id="reservationUpdatedDate" class="form-control" name="update_date" type="text" disabled v-model="updateDate" />
              <input id="reservationUpdatedTime" class="form-control" name="update_time" type="text" disabled v-model="updateTime" />
            </div>
          </div>
          <div class="form-group">
            <label for="start_ts">{{ _('Reservation starts') }}</label>
            <div class="flex-row">
              <DatePicker v-model="startDate" :max-date="endDate" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select start date')"></DatePicker>
              <input v-model="displayedStartTime" type="text" class="form-control" readonly="true" v-if="!allowTimeChange" />
              <div class="input-group" v-else>
                <TimePicker :shortLocale="shortLocale" v-model="startTime" :placeholder="_('Select start time')"/>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="end_ts">{{ _('Reservation ends') }}</label>
            <div class="flex-row">
              <DatePicker v-model="endDate" :min-date="startDate" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select end date')"></DatePicker>
              <input v-model="displayedEndTime" type="text" class="form-control" readonly="true" v-if="!allowTimeChange" />
              <div class="input-group" v-else>
                <TimePicker :shortLocale="shortLocale" v-model="endTime" :placeholder="_('Select end time')"/>
              </div>
            </div>
          </div>
          <p />
        </div>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <div class="flex-row">
          <button class="btn btn-default" v-on:click="displayOrder" type="button" v-if="isDisplayOrderVisible"><i class="fa fa-fw fa-shopping-cart"></i> {{ _('Display order') }}</button>
          <button class="btn btn-default" v-on:click="displayInvoice" type="button" v-if="isDisplayTransactionVisible"><i class="fa fa-fw fa-file"></i> {{ _('Display transaction') }}</button>
          <button class="btn btn-danger" v-on:click="remove(_('Are you sure you want to delete the reservation? Deletion can\'t be undone.'))" type="button" :disabled="!isRemoveButtonEnabled"><i class="fa fa-fw fa-trash"></i> {{ _('Delete reservation') }}</button>
        </div>
        <div class="flex-row">
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import { isAnonymized } from '~/lib/anonymization'
import { PricetierSelector, DatetimePicker } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      reservationId: 0,
      orderId: null,
      reservation: null,
      order: null,
      product: null,
      pricetiers: {},
      selectedResource: null,
      resources: [],
      resourceSeats: {}
    }
  },
  mixins: [components],
  computed: {
    isDisplayOrderVisible () {
      return this.hasOrder && !this.isModal
    },
    isDisplayTransactionVisible () {
      return this.hasInvoice && !this.isModal
    },
    isNewReservation () {
      return parseInt(this.reservationId) === 0
    },
    hasOrder () {
      if (this.reservation && this.reservation.item && this.reservation.item.order_id) {
        return true
      }
      return false
    },
    hasInvoice () {
      if (this.reservation && this.reservation.item && this.reservation.item.bill_id) {
        return true
      }
      return false
    },
    reservationTitle () {
      if (this.isNewReservation) {
        return this._('Create a new reservation')
      }
      if (this.product) {
        return this.product.name
      }
      if (this.reservation && this.reservation.client_name) {
        return this.reservation.client_name
      }
      return this._('Reservation') + (this.reservation ? ' ' + this.reservation.id : '')
    },
    startDate: {
      get () {
        return this.reservation ? DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).toJSDate() : null
      }, 
      set (newValue) {
        if (!(newValue instanceof Date)) {
          return
        }
        let n = DateTime.fromJSDate(newValue, { zone: this.timezone })
        let currentTs = Number(this.reservation.start_ts)
        if (!isNaN(currentTs)) {
          let c = DateTime.fromSeconds(currentTs, { zone: this.timezone })
          this.reservation.start_ts = n.set({ hour: c.hour, minute: c.minute }).toSeconds()
        }
      }
    },
    endDate: {
      get () {
        return this.reservation ? DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).toJSDate() : null
      }, 
      set (newValue) {
        if (!(newValue instanceof Date)) {
          return
        }
        let n = DateTime.fromJSDate(newValue, { zone: this.timezone })
        let currentTs = Number(this.reservation.end_ts)
        if (!isNaN(currentTs)) {
          let c = DateTime.fromSeconds(currentTs, { zone: this.timezone })
          this.reservation.end_ts = n.set({ hour: c.hour, minute: c.minute }).toSeconds()
        }
      }
    },
    startTime: {
      get () {
        return {
          hours: DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).hour,
          minutes: DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).minute,
          seconds: 0
        }
      },
      set (newValue) {
        if (newValue) {
          this.reservation.start_ts = DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).set({ hour: newValue.hours, minute: newValue.minutes }).toSeconds()
        } else {
          this.reservation.start_ts = null
        }
      }
    },
    endTime: {
      get () {
        return {
          hours: DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).hour,
          minutes: DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).minute,
          seconds: 0
        }
      },
      set (newValue) {
        if (newValue) {
          this.reservation.end_ts = DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).set({ hour: newValue.hours, minute: newValue.minutes }).toSeconds()
        } else {
          this.reservation.end_ts = null
        }
      }
    },
    displayedStartTime () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.start_ts), { zone: this.timezone }).toFormat(this.timeFormat) : ''
    },
    displayedEndTime () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.end_ts), { zone: this.timezone }).toFormat(this.timeFormat) : ''
    },
    creationDate () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.creation_ts), { zone: this.timezone }).toFormat(this.dateFormat) : ''
    },
    creationTime () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.creation_ts), { zone: this.timezone }).toFormat(this.timeFormat) : ''
    },
    updateDate () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.update_ts), { zone: this.timezone }).toFormat(this.dateFormat) : ''
    },
    updateTime () {
      return this.reservation ? DateTime.fromSeconds(Number(this.reservation.update_ts), { zone: this.timezone }).toFormat(this.timeFormat) : ''
    },
    dateRange () {
      if (!this.reservation || !this.startDate || !this.endDate) {
        return ''
      }
      return DateTime.fromJSDate(this.startDate, { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + this._('at') + ' ' + this.displayedStartTime + ' - ' + (DateTime.fromJSDate(this.endDate, { zone: this.timezone }).toFormat('YYYY/MM/DD') != DateTime.fromJSDate(this.startDate, { zone: this.timezone }).toFormat('YYYY/MM/DD') ? DateTime.fromJSDate(this.endDate, { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + this._('at') + ' ' : '') + this.displayedEndTime
    },
    showPricetierSelectors () {
      if (this.reservation && this.product && this.startDate && this.reservation.item && this.reservation.item.pricetiers) {
        return true
      }
      return false
    },
    // Activity pricing: ticket type rule and choice group warnings of the reservation's item. Never blocking in POS.
    itemWarnings () {
      const item = this.reservation && this.reservation.item
      if (!item) {
        return []
      }
      const list = (v) => !v ? [] : (Array.isArray(v) ? v : Object.values(v))
      const warnings = [...list(item.rule_warnings), ...list(item.optiongroups_missing)]
      return [...new Set(warnings.filter(w => w && w.message).map(w => w.message))]
    },
    showParticipantSelector () {
      if (this.showPricetierSelectors) {
        return false
      }
      if (!this.reservationId || this.reservation.count) {
        return true
      }
      return false
    },
    isOrder () {
      return this.orderId && this.order ? true : false
    },
    isOpenOrder () {
      if (this.isOrder) {
        if (this.order.payment === 'open') {
          return true
        }
      }
      return false
    },
    isConfirmedOrder () {
      if (this.isOrder) {
        if (parseInt(this.order.confirmed) === 1) {
          return true
        }
      }
      return false
    },
    isPaymentPlanOrder () {
      if (this.isOrder) {
        if (this.order.paymentplan) {
          return true
        }
      }
      return false
    },
    isInvoicedOrder () {
      if (this.isOrder) {
        for (let i = 0; i < this.order.ownItem.length; i++) {
          if (parseInt(this.order.ownItem[i].bill_id)) {
            return true
          }
        }
      }
      return false
    },
    isReservation () {
      if (!this.isOrder && this.reservation) {
        return true
      }
      return false
    },
    isAnonymizedRecord () {
      return isAnonymized(this.reservation)
    },
    anonymizedLockStatus () {
      return this._('This record has been anonymized and cannot be modified.')
    },
    isLocked () {
      return this.isInvoicedOrder
    },
    showOrderFields () {
      // Disabled the advanced open order / confirmed order editing option because everything new is shit
      return false
      // return this.isOpenOrder || this.isConfirmedOrder
    },
    showReservationFields () {
      return this.isReservation || this.isInvoicedOrder
    },
    allowTimeChange () {
      // Why the F was this implemented like this?
      /*
      if (this.showOrderFields) {
        return false
      }
      */
      return true
    },
    isRemoveButtonEnabled () {
      if(!this.reservation) {
        return false
      }
      return !this.saving && !this.saved && !this.loading && !this.locked
    },
    isSaveButtonEnabled () {
      if(!this.reservation || this.reservation.start_ts >= this.reservation.end_ts) {
        return false
      }
      return !this.saving && !this.saved && !this.loading && !this.locked && !this.isAnonymizedRecord
    }
  },
  methods: {
    getResourceCount(resource) {
      let c =  0
      let base = parseInt(resource.count, 10) 
      let extra = parseInt(resource.extracount, 10) 
      if (base) {
        c += base
      }
      if (extra) {
        c += extra
      }
      return c
    },
    checkIn() {
      this.checkInOrOut('in')
    },
    checkOut() {
      this.checkInOrOut('out')
    },
    cancelCheckIn() {
      this.checkInOrOut('in', true)
    },
    cancelCheckOut() {
      this.checkInOrOut('out', true)
    },
    displayOrder () {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'OrderDetails',
        title: this._('Order') + ' ' + this.reservation.item.order_id,
        width: 6,
        data: {
          orderId: this.reservation.item.order_id,
          trail: this.componentTrail
        }
      })
    },
    displayInvoice () {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'InvoiceDetails',
        title: this._('Invoice') + ' ' + this.reservation.item.bill_id,
        width: 6,
        data: {
          invoiceId: this.reservation.item.bill_id,
          trail: this.componentTrail
        }
      })
    },
    async doRemove () {
      let response
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/reservations/' + this.reservation.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deleting the reservation failed!'))
      }
      this.showNotification(this._('Reservation deleted!'))
      this.EventBus.$emit('reservationRemove', { id: this.reservation.id })
      this.close()
    },
    async checkInOrOut(mode, cancel) {
      let data = {
        identifier: this.reservation.identifier
      }
      if (mode === 'in') {
        if (cancel) {
          data.checkin_ts = null
        } else {
          data.checkin_ts = 'now'
        }
      } else {
        if (cancel) {
          data.checkout_ts = null
        } else {
          data.checkout_ts = 'now'
        }
      }
      let response
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/reservations/' + this.reservation.identifier + '.json?apikey=' + this.apiKey, data)
      } catch(e) {}
      this.loadReservation(this.reservation.id)
    },
    async loadReservation (id) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/reservations/' + id + '.json?items=true&resources=true&seats=true&pin=true&apikey=' + this.apiKey)
      } catch (e) {
        this.showError(e)
        return
      }
      this.reservation = response.data
      this.setPricetiers(this.reservation.pricetiers)
      this.setResourceSeats(this.reservation.sharedSeat)
      if (parseInt(this.reservation.product_id)) {
        this.loadProduct(this.reservation.product_id)
      } else {
        this.product = null
      }
    },
    async loadOrder (id) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/orders/' + id + '.json?items=true&apikey=' + this.apiKey)
      } catch (e) {
        this.showError(e)
        return
      }
      this.order = response.data
    },
    setPricetiers (pricetierStr) {
      let $this = this
      if (!pricetierStr) {
        return
      }
      let ptArr = pricetierStr.split(';')
      Object.keys(this.pricetiers).forEach(function(key) { delete $this.pricetiers[key] })
      for (let i = 0; i < ptArr.length; i++) {
        let pArr = ptArr[i].split(':')
        this.pricetiers[pArr[0]] = pArr[1]
      }
    },
    setResourceSeats (seats) {
      if (!seats || !seats.length) {
        return
      }
      for (let i = 0; i < seats.length; i++) {
        let s = seats[i]
        if (!this.resourceSeats[s.resource_id]) {
          this.resourceSeats[s.resource_id] = 0
        }
        this.resourceSeats[s.resource_id]++
      }
    },
    async loadProduct (id) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/products/' + id + '.json?apikey=' + this.apiKey)
        this.product = response.data
      } catch (e) {
        // Let's not panic if the product associated to this reservation has been deleted
        if (e && e.response && e.response.status && parseInt(e.response.status, 10) === 404) {
          this.product = null
          return
        }
        this.showError(e)
        return
      }
    },
    onResourceSearch (search, loading) {
      loading(true)
      this.findResources(loading, search, this)
    },
    findResources: debounce(async (loading, search, $this) => {
      let response
      try {
        response = await axios.get(`${$this.baseDomain}${$this.shopId}/${$this.locale}/resources.json?sSearch=${encodeURIComponent(search)}&iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=${$this.apiKey}`)
      } catch (e) {}
      // $this.resources = response.data.filter(r => r.displayedtype !== 'openinghours')
      $this.resources = response.data
      loading(false)
    }, 350),
    addResource () {
      if (!this.selectedResource) {
        return
      }
      let resources = this.reservation.sharedResource
      let matches = resources.filter(r => r.id === this.selectedResource.id)
      if (matches.length) {
        return this.showError(this._('The resource has already been added to this reservation.'))
      }
      resources.push(this.selectedResource)
      this.resourceSeats[this.selectedResource.id] = 1
      this.reservation.sharedResource = resources
      this.selectedResource = null
    },
    removeResource (resource) {
      this.showDialog({
        title: this._('Remove resource from this reservation?'),
        buttons: [
          {
            title: this._('OK'),
            class: 'success',
            icon: 'trash',
            handler: () => {
              this.reservation.sharedResource = this.reservation.sharedResource.filter(r => r.id !== resource.id )
            }
          }, 
          {
            title: this._('Cancel'),
            icon: 'undo',
            handler: () => {}
          }
        ]
      })
    },
    async save () {
      this.saving = true
      let r = this.reservation
      let data = {}
      let newItem = null
      // This is now always false because everything new is shit
      if (this.showOrderFields) {
        let o = this.order
        let item = null
        for (let i = 0; i < o.ownItem.length; i++) {
          item = o.ownItem[i]
          if (item.id === r.item_id) {
            break
          }
        }
        if (item) {
          if (item.start_ts !== r.start_ts || item.end_ts !== r.end_ts || item.reservation_count !== r.count) {
            data = {
              count: item.count,
              reservation_count: r.count,
              resource_count: item.resource_count,
              product_id: item.product_id,
              reservation_datestart: DateTime.fromSeconds(Number(r.start_ts), { zone: this.timezone }).toFormat(this.dateFormat),
              reservation_dateend: DateTime.fromSeconds(Number(r.end_ts), { zone: this.timezone }).toFormat(this.dateFormat),
              reservation_timestart: this.allowTimeChange ? DateTime.fromSeconds(Number(r.start_ts), { zone: this.timezone }).toFormat(this.timeFormat) : '12.00',
              reservation_timeend: this.allowTimeChange ? DateTime.fromSeconds(Number(r.end_ts), { zone: this.timezone }).toFormat(this.timeFormat) : '12.00',
              version: o.version,
              override_times: true
            }
            if (item.rateplan_id) { // Activity pricing: keep the rate plan of a price row product
              data.rateplan_id = item.rateplan_id
            }
            if (this.showPricetierSelectors) {
              let totalParticipants = 0
              for (let ptId in this.pricetiers) {
                if (Object.prototype.hasOwnProperty.call(this.pricetiers, ptId)) {
                  if (this.pricetiers[ptId]) {
                    data['pricetier_' + ptId] = this.pricetiers[ptId]
                    totalParticipants += parseInt(this.pricetiers[ptId], 10)
                  }
                }
              }
              data.count = totalParticipants // Override item.count
            }
            try {
              await axios.delete(this.baseDomain + this.shopId + '/orders/' + this.orderId + '/items/' + item.id + '.json?apikey=' + this.apiKey, { id: item.id })
            } catch (e) {
              // this.saving = false
              // return this.showError(e)
            }
            try {
              await axios.delete(this.baseDomain + this.shopId + '/reservations/' + r.id + '.json?apikey=' + this.apiKey, { id: r.id })
            } catch (e) {
              // this.saving = false
              // return this.showError(e)
            }
            try {
              response = await axios.post(this.baseDomain + this.shopId + '/orders/' + this.orderId + '/items.json?apikey=' + this.apiKey, data)
            } catch (e) {
              // If the save fails, let's try to revert to our previous state
              data = {
                count: item.count,
                reservation_count: item.reservation_count,
                resource_count: item.resource_count,
                product_id: item.product_id,
                reservation_datestart: DateTime.fromSeconds(Number(item.start_ts), { zone: this.timezone }).toFormat(this.dateFormat),
                reservation_dateend: DateTime.fromSeconds(Number(item.end_ts), { zone: this.timezone }).toFormat(this.dateFormat),
                reservation_timestart: this.allowTimeChange ? DateTime.fromSeconds(Number(item.start_ts), { zone: this.timezone }).toFormat(this.timeFormat) : '12.00',
                reservation_timeend: this.allowTimeChange ? DateTime.fromSeconds(Number(item.end_ts), { zone: this.timezone }).toFormat(this.timeFormat) : '12.00',
                version: o.version,
                override_times: true
              }
              if (item.rateplan_id) {
                data.rateplan_id = item.rateplan_id
              }
              if (this.showPricetierSelectors) {
                for (let ptId in this.pricetiers) {
                  if (Object.prototype.hasOwnProperty.call(this.pricetiers, ptId)) {
                    data['pricetier_' + ptId] = this.pricetiers[ptId]
                  }
                }
              }
              try {
                response = await axios.post(this.baseDomain + this.shopId + '/orders/' + this.orderId + '/items.json?apikey=' + this.apiKey, data)
              } catch (e) {
                this.saving = false
                return this.showError(e)
              }
              this.close() // We have to close so the deleted reservation doesn't remain on screen
              this.saving = false
              return this.showError(e)
            }
            newItem = response.data
            try {
              response = await axios.get(this.baseDomain + this.shopId + '/orders/' + this.orderId + '.json?items=true&reservations=true&apikey=' + this.apiKey)
            } catch (e) {
              this.saving = false
              this.showError(e)
              return
            }
            let newOrder = response.data
            for (let i = 0; i < newOrder.ownItem.length; i++) {
              item = newOrder.ownItem[i]
              if (item.id == newItem) {
                this.component.initData.reservationId = this.reservation.id = r.id = item.ownReservation[0].id
              }
            }
          }
          data = {
            id: o.id,
            name: r.client_name,
            company: r.client_company,
            email: r.client_email,
            phone: r.client_phone,
            more: r.client_more,
            notes: o.notes,
            permanent: 1 // This updates the reservation, too
          }
          try {
            response = await axios.put(this.baseDomain + this.shopId + '/orders/' + o.id + '.json?apikey=' + this.apiKey, data)
          } catch(e) {
            this.saving = false
            return this.showError(e)
          }
          // We need to do the next save if we happened to change the resources
          /*
          this.saved = true
          this.saving = false
          setTimeout(() => { this.saved = false }, 1000)
          this.showNotification(this._('Changes saved successfully!'))
          if (this.saveShouldClose) {
            this.close()
          }
          return
          */
        }
      }
      data = {
        source: 'editor',
        id: r.id,
        client_name: r.client_name,
        client_company: r.client_company,
        client_email: r.client_email,
        client_phone: r.client_phone,
        client_more: r.client_more,
        count: r.count,
        start_ts: r.start_ts,
        end_ts: r.end_ts,
        resources: r.sharedResource.map(sr => sr.id + ':::' + sr.name + ':::' + this.resourceSeats[sr.id]).join(';;;')
      }
      if (this.showPricetierSelectors) {
        let totalParticipants = 0
        for (let ptId in this.pricetiers) {
          if (Object.prototype.hasOwnProperty.call(this.pricetiers, ptId)) {
            if (this.pricetiers[ptId]) {
              data['pricetier_' + ptId] = this.pricetiers[ptId]
              totalParticipants += parseInt(this.pricetiers[ptId], 10)
            }
          }
        }
        data.count = totalParticipants
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/reservations/' + r.id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      this.saved = true
      this.saving = false
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      if (this.saveShouldClose) {
        this.close()
      }
    }
  },
  watch: {
    reservationId (newValue) {
      if (parseInt(newValue)) {
        this.loadReservation(newValue)
      }
    },
    orderId (newValue) {
      if (parseInt(newValue)) {
        this.loadOrder(newValue)
      }
    },
    pricetiers: {
      deep: true,
      handler (pricetiers) {
        let ptArr = []
        for (let id in pricetiers) {
          if (Object.prototype.hasOwnProperty.call(pricetiers, id)) {
            ptArr.push(id + ':' + pricetiers[id])
          }
        }
        this.reservation.pricetiers = ptArr.join(';')
      }
    }
  },
  components: {
    PricetierSelector,
    DatetimePicker
  },
  created () {
    if (this.component && this.component.initData) {
      this.reservationId = this.component.initData.reservationId
      this.orderId = this.component.initData.orderId
    }
  },
  updated () {
    if (this.component && this.component.initData) {
      if (!this.reservation || !this.reservation.id || parseInt(this.reservation.id, 10) !== parseInt(this.component.initData.reservationId, 10)) {
        this.reservationId = this.component.initData.reservationId
        this.orderId = this.component.initData.orderId
      }
    }
  }
}
</script>

<style scoped>
.removeitem {
  cursor: pointer;
}
.well-info {
  background-color: #d9edf7;
}
.well-warning {
  background-color: #fcf8e3;
}
.well {
  margin-top: 5px;
  margin-bottom: 5px;
}
.well h3 {
  margin-top: 10px;
  margin-bottom: 8px;
  font-size: 18px;
}
</style>
<style>
.resourceSelector .dropdown-toggle {
  height: 44px;
  border-radius: 0px;
}
.resourceSelector .dropdown-menu {
  border-radius: 0px;
}
</style>